import { useCallback } from 'react';
import {
  ScratchpadRecommendation,
  ScratchpadRecommendationRequestType,
  useCreateScratchpadRecommendationMutation,
} from '../../../../../api/graphql/generated';
import { FlowItem } from '../../model/flow.types';

type GetRecommendationForFormType<Config> = (
  form: FlowItem,
  config: Config
) => Promise<ScratchpadRecommendation | undefined>;

interface GetRecommendationForFormOptions {
  appSlug: string;
  recommendationType: ScratchpadRecommendationRequestType;
}

const useCreateRecommendationForForm = <FlowConfig = Record<string, unknown>>(
  options: GetRecommendationForFormOptions
): GetRecommendationForFormType<FlowConfig> => {
  const { appSlug, recommendationType } = options;
  const [createScratchpadRecommendation] =
    useCreateScratchpadRecommendationMutation();

  const createRecommendationForForm: GetRecommendationForFormType<FlowConfig> =
    useCallback(
      async (
        flowItem: FlowItem,
        flowConfig: FlowConfig
      ): Promise<ScratchpadRecommendation | undefined> => {
        const recommendation = await createScratchpadRecommendation({
          variables: {
            input: {
              appSlug,
              type: recommendationType,
              inputs: {
                flowItem,
                flowConfig,
              },
            },
          },
        });

        return recommendation.data?.createScratchpadRecommendation;
      },
      [appSlug, createScratchpadRecommendation, recommendationType]
    );

  return createRecommendationForForm;
};

export { useCreateRecommendationForForm };
